import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/Layout'

/* Router Modules */
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'

/** note: Submenu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    roles: ['admin','editor']     will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if true ,the page will no be cached(default is false)
  }
**/
export var constantRouterMap = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/authredirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: 'dashboard', icon: 'home', noCache: true }
      }
    ]
  }
]

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  {
    path: '/baseModule',
    component: Layout,
    redirect: '/baseModule',
    name: 'baseModule',
    meta: {
      title: 'baseModule',
      icon: 'base',
      noCache: true
    },
    children: [
      {
        path: '/statusManage',
        component: () => import('@/views/baseModule/statusManage'),
        name: 'statusManage',
        meta: { title: 'statusManage' }
      },
      {
        path: '/applicationManage',
        component: () => import('@/views/baseModule/applicationManage'),
        name: 'applicationManage',
        meta: { title: 'applicationManage' }
      },
      {
        path: '/roleManage',
        component: () => import('@/views/baseModule/roleManage'),
        name: 'roleManage',
        meta: { title: 'roleManage' }
      }
    ]
  },
  {
    path: '/accountManage',
    component: Layout,
    redirect: '/accountManage',
    name: 'userManages',
    meta: {
      title: 'userManages',
      icon: 'acount',
      noCache: true
    },
    children: [
      {
        path: '/userManage',
        component: () => import('@/views/accountManage/userManage'),
        name: 'userManage',
        meta: { title: 'userManage' }
      },
      {
        path: '/userAccountFlow',
        component: () => import('@/views/accountManage/userAccountFlow'),
        name: 'userAccountFlow',
        meta: { title: 'userAccountFlow' }
      }
    ]
  },
  {
    path: '/shopManage',
    component: Layout,
    redirect: '/shopManage',
    name: 'shopManages',
    meta: {
      title: 'shopManages',
      icon: 'field',
      noCache: true
    },
    children: [
      {
        path: '/shopList',
        component: () => import('@/views/shopManage/shopList'),
        name: 'shopList',
        meta: { title: 'shopList' }
      }
    ]
  },
  {
    path: '/fieldManage',
    component: Layout,
    redirect: '/fieldManage',
    name: 'fieldManages',
    meta: {
      title: 'fieldManages',
      icon: 'field',
      noCache: true
    },
    children: [
      {
        path: '/fieldList',
        component: () => import('@/views/fieldManage/fieldList'),
        name: 'fieldList',
        meta: { title: 'fieldList' }
      }
    ]
  },

  {
    path: '/deviceManage',
    component: Layout,
    redirect: '/device',
    name: 'deviceManage',
    meta: {
      title: 'deviceManage',
      icon: 'device',
      noCache: true
    },
    children: [
      {
        path: '/deviceList',
        component: () => import('@/views/device/deviceList'),
        name: 'deviceList',
        meta: { title: 'deviceList' }
      }
    ]
  },
  {
    path: '/orderManage',
    component: Layout,
    redirect: '/orderManage',
    name: 'orderManages',
    meta: {
      title: 'orderManage',
      icon: 'order',
      noCache: true
    },
    children: [
      {
        path: '/orderList',
        component: () => import('@/views/orderManage/orderList'),
        name: 'orderManage',
        meta: { title: 'orderManage' }
      }
    ]
  },

  {
    path: '/reportManage',
    component: Layout,
    redirect: '/reportManage',
    name: 'reportManage',
    meta: {
      title: 'reportManage',
      icon: 'place',
      noCache: true
    },
    children: [
      {
        path: '/agentIncomeTotal',
        component: () => import('@/views/report/agentIncomeTotal'),
        name: 'agentIncomeTotal',
        meta: { title: 'agentIncomeTotal' }
      },
      {
        path: '/localIncomeTotal',
        component: () => import('@/views/report/localIncomeTotal'),
        name: 'localIncomeTotal',
        meta: { title: 'localIncomeTotal' }
      },
      {
        path: '/report',
        component: () => import('@/views/report/reportManage'),
        name: 'Report',
        meta: { title: 'report' }
      }
    ]
  },
  {
    path: '/advManage',
    component: Layout,
    redirect: '/advManage',
    name: 'advManage',
    meta: {
      title: 'advertiseManage',
      icon: 'advertise',
      noCache: true
    },
    children: [
      {
        path: '/advList',
        component: () => import('@/views/advManage/advList'),
        name: 'advList',
        meta: { title: 'advList' }
      },
      {
        path: '/putPlan',
        component: () => import('@/views/advManage/putPlan'),
        name: 'putPlan',
        meta: { title: 'putPlan' }
      }
    ]
  },

  {
    path: '/audit',
    component: Layout,
    redirect: '/audit',
    name: 'adver',
    meta: {
      title: 'courierAudit',
      icon: 'excel',
      noCache: true
    },
    children: [
      {
        path: '/audits',
        component: () => import('@/views/Audit/audit'),
        name: 'courierAudit',
        meta: { title: 'courierAudit' }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account',
    name: 'accountManage',
    meta: {
      title: 'accountManage',
      icon: 'finace',
      noCache: true
    },
    children: [

      {
        path: '/transferAccount',
        component: () => import('@/views/account/transferAccount'),
        name: 'transferAccount',
        meta: { title: 'transferAccount' }
      },
      { // 账户流水
        path: '/accountFlow',
        component: () => import('@/views/account/accountFlow'),
        name: 'accountFlow',
        meta: { title: 'accountFlow' }
      },
      {
        path: '/cashaudit',
        component: () => import('@/views/account/cashaudit'),
        name: 'cashaudit',
        meta: { title: 'cashaudit' }
      },
      { // 提现审核
        path: '/withdrawalAudit',
        component: () => import('@/views/account/withdrawalAudit'),
        name: 'withdrawalAudit',
        meta: { title: 'withdrawalAudit' }
      },
      { // 用户
        path: '/userWithdrawalAudit',
        component: () => import('@/views/account/userWithdrawalAudit'),
        name: 'userWithdrawalAudit',
        meta: { title: 'userWithdrawalAudit' }
      },
      // { // 余额发放扣除
      //   path: '/deductRem',
      //   component: () => import('@/views/account/deductRem'),
      //   name: 'deductRem',
      //   meta: { title: 'deductRem' }
      // },
      { // 提现记录
        path: '/withdrawRecord',
        component: () => import('@/views/account/withdrawRecord'),
        name: 'withdrawRecord',
        meta: { title: 'withdrawRecord' }
      },
      { // 提现配置
        path: '/config',
        component: () => import('@/views/account/config'),
        name: 'config',
        meta: { title: 'config' }
      }
      // { // 退款记录
      //   path: '/refundRecord',
      //   component: () => import('@/views/account/refundRecord'),
      //   name: 'refundRecord',
      //   meta: { title: 'refundRecord' }
      // },
      // { // 充值费用设置（包月模式充值金额设置）
      //   path: '/setCosts',
      //   component: () => import('@/views/account/setCosts'),
      //   name: 'setCosts',
      //   meta: { title: 'setCosts' }
      // }
    ]
  },
  {
    path: '/opreations',
    component: Layout,
    redirect: '/versionUpdate',
    name: 'operation',
    meta: {
      title: 'operation',
      icon: 'excel',
      noCache: true
    },
    children: [
      {
        path: '/versionUpdate',
        component: () => import('@/views/operation/versionUpdate'),
        name: 'versionUpdate',
        meta: { title: 'versionUpdate' }
      },
      {
        path: '/feedback',
        component: () => import('@/views/operation/feedback/index'),
        name: 'feedback',
        meta: { title: 'feedback' }
      }
    ]
  },
  {
    path: '/error',
    component: Layout,
    redirect: 'noredirect',
    name: 'ErrorPages',
    meta: {
      title: 'errorPages',
      icon: '404'
    },
    children: [
      {
        path: '401',
        component: () => import('@/views/errorPage/401'),
        name: 'Page401',
        meta: { title: 'page401', noCache: true }
      },
      {
        path: '404',
        component: () => import('@/views/errorPage/404'),
        name: 'Page404',
        meta: { title: 'page404', noCache: true }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]
